import React from "react";

// Files Import
import TeamCarousel from "../Carousel/TeamCarousel/TeamCarousel";
import StyledMdText from "../../common/components/styledMdText/StyledMdText";
import StyledH2Heading from "../../common/components/styledH2Heading/StyledH2Heading";
import StyledH6Heading from "../../common/components/styledH6Heading/StyledH6Heading";

const Artists = ({ custom }) => {
  return (

    <div className="relative flex items-center justify-center w-full py-16  artistBg">
      <div className="w-[90%]  md:w-[80%] flex flex-col justify-center items-center gap-4 md:gap-10 ">
        {/* Heading */}
        <div className="flex flex-col items-center justify-center text-center gap-2 ">
          {!custom && <StyledH6Heading>Behind the story</StyledH6Heading>}

          {!custom ? (
            <StyledH2Heading>Our Heroes</StyledH2Heading>
          ) : (
            <StyledH2Heading fontColor={"!text-[34px] sm:!text-h2"}>
              Artist Behind The Art
            </StyledH2Heading>
          )}

          {!custom ? (
            <StyledMdText fontColor={"text-center"}>
              We have a team of super heroes who did this unbelievable work.
            </StyledMdText>
          ) : (
            <StyledMdText fontColor={`${custom ? 'w-4/5' : 'w-[80%]'} px-2 md:px-0  text-center `}>
              We have a brilliant team of artist who has shown their
              extra-ordinary work in these Golden NFTs collection
            </StyledMdText>
          )}
        </div>

        <div className="px-6 sm:px-14 md:px-0 w-full  TeamCarousel">
          <TeamCarousel />
        </div>
      </div>
    </div>
  );
};

export default Artists;
